import { ResponsiveMax, ResponsiveSizes, ResponsivePathName } from '@/app-constants';

/* eslint no-useless-escape: off */
const imgRegex = new RegExp(`^(.*?)\.([^\.]*)$`);

/* eslint import/prefer-default-export: off */
/*
  url: url of image to display
  width: width of page it will take up, in pixels
*/
export const getResponsiveUrl = function(url, width) {
  const match = url.match(imgRegex);
  const path = match[1];
  const ext = match[2];

  let size = ResponsiveMax;
  for (let idx = 0; idx < ResponsiveSizes.length; idx += 1) {
    const rSize = ResponsiveSizes[idx];
    if (width <= rSize) {
      size = rSize;
      break;
    }
  }

  const split = path.split('/');
  split.splice(split.length - 1, 0, ResponsivePathName);
  const newPath = split.join('/');
  return [newPath, `-${size}`, '.', ext].join('');
};



// WEBPACK FOOTER //
// ./src/utils/image-utils.js